import piincHttp from '@/util/configureAxios.js';

const BROWSER_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'txt'];
const OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

function isPublicUrl(url) {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname;
    const local = host === 'localhost' || host.endsWith('.localhost') || host.endsWith('.test') || host.endsWith('.local')
      || /^127\./.test(host) || /^10\./.test(host) || /^192\.168\./.test(host) || /^172\.(1[6-9]|2\d|3[01])\./.test(host);
    return parsed.protocol === 'https:' && !local;
  } catch (e) {
    return false;
  }
}

function extensionOf(file) {
  const name = (file && file.file_name) || '';
  const dot = name.lastIndexOf('.');
  return dot >= 0 ? name.substring(dot + 1).toLowerCase() : '';
}

/**
 * Download a document through the API
 *
 * @param {Object} file Media item with id and file_name
 */
export function downloadDocument(file) {
  piincHttp.get('documents/' + file.id + '/download', {responseType: 'blob'}).then(function(response) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.download = file.file_name;

    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }, function() {});
}

/**
 * Open a document in a new browser tab instead of downloading it: images, PDFs and text open in the browser,
 * Office files open in the Office viewer. Other files (e.g. zip) are downloaded.
 *
 * @param {Object} file Media item with id, file_name and the token url from the API
 */
export function openDocument(file) {
  const extension = extensionOf(file);

  if (file.url && BROWSER_EXTENSIONS.includes(extension)) {
    window.open(file.url, '_blank', 'noopener');
    return;
  }

  // The Office viewer fetches the file from Microsoft's servers, so it only works when the file URL is public
  if (file.url && OFFICE_EXTENSIONS.includes(extension) && isPublicUrl(file.url)) {
    window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(file.url), '_blank', 'noopener');
    return;
  }

  downloadDocument(file);
}
